/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Write serializer for updating custom field values (PATCH/PUT by ID).
 * @export
 * @interface CustomFieldValueUpdate
 */
export interface CustomFieldValueUpdate {
  /**
   *
   * @type {string}
   * @memberof CustomFieldValueUpdate
   */
  textValue?: string | null;
  /**
   *
   * @type {Blob}
   * @memberof CustomFieldValueUpdate
   */
  fileValue?: Blob | null;
}

/**
 * Check if a given object implements the CustomFieldValueUpdate interface.
 */
export function instanceOfCustomFieldValueUpdate(value: object): value is CustomFieldValueUpdate {
  return true;
}

export function CustomFieldValueUpdateFromJSON(json: any): CustomFieldValueUpdate {
  return CustomFieldValueUpdateFromJSONTyped(json, false);
}

export function CustomFieldValueUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomFieldValueUpdate {
  if (json == null) {
    return json;
  }
  return {
    textValue: json['text_value'] == null ? undefined : json['text_value'],
    fileValue: json['file_value'] == null ? undefined : json['file_value'],
  };
}

export function CustomFieldValueUpdateToJSON(value?: CustomFieldValueUpdate | null): any {
  if (value == null) {
    return value;
  }
  return {
    text_value: value['textValue'],
    file_value: value['fileValue'],
  };
}
